import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { Loader } from '../../components/shared/Loader';
import { StrategicPlan } from '../strategy/StrategicPlan';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

function StrategicPlanWrapper() {
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const assertionDescriptorStrategyLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Strategy
    );

        const assertionDescriptorSignificantChangesLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Note
    );

    if (assertionDescriptorStrategyLookup.isFetching || assertionDescriptorSignificantChangesLookup.isFetching) {
        return <Loader />;
    }

    return (
        <>
            <DocumentTitle title="Strategic Plan"></DocumentTitle>
            <StrategicPlan
                user={user}
                refreshIdentifier={key}
                zoneContext={zoneContext}
                assertionDescriptorsStrategy={assertionDescriptorStrategyLookup.data ?? []}
                assertionDescriptorsSignificantChanges={assertionDescriptorSignificantChangesLookup.data ?? []}
            />
        </>
    );
}

export default StrategicPlanWrapper;
